import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20peach%20blossom%20themed%20cinematic%20scene%20with%20abstract%20flowing%20petals%20in%20soft%20pink%20and%20coral%20tones%2C%20dreamy%20bokeh%20effect%2C%20elegant%20minimal%20composition%2C%20gradient%20from%20warm%20pink%20to%20deep%20crimson%2C%20artistic%20abstract%20background%2C%20soft%20ethereal%20glow%2C%20high%20end%20cinematic%20look&width=1920&height=800&seq=taohua-hero&orientation=landscape"
          alt="桃花视频 - 高清影视在线观看"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          桃花视频
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源
          <br className="hidden md:block" />
          高清免费在线观看，电视剧全集、电影大全一网打尽，流畅不缓冲
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/dianshiju"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            热门电视剧 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
          <Link
            to="/category/dianying"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm backdrop-blur-sm transition-all cursor-pointer whitespace-nowrap"
          >
            最新电影 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        {/* Stats */}
        <div className="flex items-center gap-8 md:gap-12 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">12,000+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">影视资源</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">50万+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">每日播放</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">99.8%</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">流畅率</p>
          </div>
        </div>
      </div>
    </section>
  );
}